import React, {Component} from 'react';

export default class Print extends Component {

    print() {
        window.print();
    }

    render() {

        return (
            <button className="print"
                    onClick={ () => this.print() }>
                PRINT
            </button>
        )
    }
}



// WEBPACK FOOTER //
// src/client/components/common/elements/Print.js